/**
 * Lenis Smooth Scrolling Initialization
 * https://github.com/darkroomengineering/lenis
 */

document.addEventListener('DOMContentLoaded', function () {
  // Check if Lenis is available
  if (typeof Lenis === 'undefined') {
    return;
  }

  // Initialize Lenis
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: false,
    touchMultiplier: 2,
    infinite: false,
  });

  // Add class to html element to indicate Lenis is active
  document.documentElement.classList.add('lenis', 'lenis-smooth');

  // Update Lenis on scroll
  let rafId;
  function raf(time) {
    lenis.raf(time);
    rafId = requestAnimationFrame(raf);
  }
  rafId = requestAnimationFrame(raf);

  // Stop Lenis when user prefers reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    lenis.stop();
    document.documentElement.classList.remove('lenis-smooth');
    document.documentElement.classList.add('lenis-reduced-motion');
  }

  // Store event listeners for cleanup
  let resizeListener = () => lenis.resize();
  let sectionLoadListener = () => lenis.resize();
  let sectionUnloadListener = () => lenis.resize();
  let sectionSelectListener = () => lenis.resize();
  let sectionDeselectListener = () => lenis.resize();

  // Handle window resize
  window.addEventListener('resize', resizeListener);

  // Expose lenis globally for potential use in other scripts
  window.lenis = lenis;

  // Handle smooth scrolling for anchor links
  let anchorListeners = [];
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    const listener = function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        lenis.scrollTo(target, {
          offset: 0,
          duration: 1.2,
        });
      }
    };
    anchor.addEventListener('click', listener);
    anchorListeners.push({ element: anchor, listener });
  });

  // Re-initialize when Shopify sections are loaded/reloaded
  document.addEventListener('shopify:section:load', sectionLoadListener);
  document.addEventListener('shopify:section:unload', sectionUnloadListener);
  document.addEventListener('shopify:section:select', sectionSelectListener);
  document.addEventListener('shopify:section:deselect', sectionDeselectListener);

  // Cleanup function for bfcache compatibility
  function cleanup() {
    // Cancel animation frame
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }

    // Destroy Lenis instance
    if (lenis && lenis.destroy) {
      lenis.destroy();
    }

    // Remove event listeners
    window.removeEventListener('resize', resizeListener);
    document.removeEventListener('shopify:section:load', sectionLoadListener);
    document.removeEventListener('shopify:section:unload', sectionUnloadListener);
    document.removeEventListener('shopify:section:select', sectionSelectListener);
    document.removeEventListener('shopify:section:deselect', sectionDeselectListener);

    // Remove anchor listeners
    anchorListeners.forEach(({ element, listener }) => {
      element.removeEventListener('click', listener);
    });
    anchorListeners = [];

    // Remove global reference
    if (window.lenis) {
      delete window.lenis;
    }

    // Remove classes
    document.documentElement.classList.remove('lenis', 'lenis-smooth', 'lenis-reduced-motion');
  }

  // Clean up on page unload for bfcache compatibility
  window.addEventListener('pagehide', cleanup);
  window.addEventListener('beforeunload', cleanup);
});
